<div class="service-confirm">
  <button mat-icon-button class="close-button" (click)="closeAllDialogs()">
    <mat-icon>close</mat-icon>
  </button>
  <div class="service-confirm__container">
  @if (serviceRescheduleState.rescheduleServiceMutation.result$ | async; as
  mutationState) { @if (mutationState.isPending) {
  <div class="py-4 px-4 flex flex-col items-center justify-center">
    <div class="mt-11 flex justify-center w-full">
      <app-horus-loading></app-horus-loading>
    </div>
  </div>
  } @else if (mutationState.isSuccess && mutationState.data!.success) {
      <app-horus-message-general
        nameIcon="successMessageIcon"
        btnAction="ACEPTAR"
        size="M"
        (action)="closeAllDialogs()"
      >
        <div class="confirm__content">
          <span class="confirm__content__title confirm__content__title--success"
            >¡Listo!</span
          >
          <span class="confirm__content__text"
            >Reprogramaste el servicio de <br />
            manera correcta.</span
          >
        </div>
      </app-horus-message-general>
  } @else if (serviceRescheduleState.isBusinessRuleError()) {
    <app-horus-message-general
      size="L"
      nameIcon="noDataMessageIcon"
      btnAction="INGRESAR TICKET"
      btnCancel="CANCELAR"
      (action)="redirectToAria()"
      (actionCancel)="closeAllDialogs()"
    >
      <span style="color:#F6D44D; font-size: 14px; line-height: 25px;">No podemos ejecutar la acción</span><br>
      <span style="font-weight: 400;">Este servicio ya no puede ser reprogramado. Si aún deseas continuar con este proceso, ingresa un ticket.</span>
    </app-horus-message-general>
  } @else if (serviceRescheduleState.isGeneralMutationError() || (mutationState.isSuccess && !mutationState.data!.success)) {
    <app-horus-message-general
      size="L"
      nameIcon="errorMessageIcon"
      btnAction="INTENTAR NUEVAMENTE"
      (action)="retry()"
      btnCancel="CANCELAR"
      (actionCancel)="closeAllDialogs()"
    >
      <span style="color:#F14B26; font-size: 14px; line-height: 25px;">Lo sentimos</span><br>
      Hubo un error al intentar reprogramar el servicio.
    </app-horus-message-general>
  } @else {
  <div class="py-4 px-4 flex flex-col items-center justify-center">
    <div class="confirm__body">
      <div class="confirm__body__icon">
        <mat-icon svgIcon="iconCalendar"></mat-icon>
      </div>
      <div class="confirm__body__message">
        <span
          >Estás punto de reprogramar este servicio para el</span
        >
        <span class="confirm__body__message__date">
          <mat-icon>calendar_today</mat-icon>
          {{ data.request.date | availableDatePipe }}
        </span>
        <span class="confirm__body__message__question">¿Quieres confirmar la <strong>reprogramación</strong>?</span>
      </div>
      <div class="confirm__body__actions">
        <button
          horusBtn
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          class="w-full"
          (click)="closeDialog()"
        >
          CANCELAR
        </button>
        <button
          horusBtn
          horusBtnSize="md"
          class="w-full"
          (click)="confirmReschedule()"
        >
          CONFIRMAR
        </button>
      </div>
    </div>
  </div>
  } } @else {
  <div class="py-4 px-4 flex flex-col items-center justify-center">
    <div class="confirm__body">
      <div class="confirm__body__icon">
        <mat-icon svgIcon="iconCalendar"></mat-icon>
      </div>
      <div class="confirm__body__message">
        <span
          >Estás a punto de reprogramar la entrega de este servicio para el</span
        >
        <span class="confirm__body__message__date">
          <mat-icon>calendar_today</mat-icon>
          {{ data.request.date | availableDatePipe }}
        </span>
        <span class="confirm__body__message__question">¿Quieres confirmar la <strong>reprogramación</strong>?</span>
      </div>
      <div class="confirm__body__actions">
        <button
          horusBtn
          horusBtnVariant="outline-default"
          horusBtnSize="md"
          class="w-full"
          (click)="closeDialog()"
        >
          CANCELAR
        </button>
        <button
          horusBtn
          horusBtnSize="md"
          class="w-full"
          (click)="confirmReschedule()"
        >
          CONFIRMAR
        </button>
      </div>
    </div>
  </div>
  }
  </div>
</div>
